module.exports = __webpack_public_path__ + "img/j3pz.c53125cb.svg";